import {Observable, throwError as observableThrowError} from 'rxjs';
import {CustomHttp} from '../../core/http-custom/http-custom.service';
import {Injectable} from '@angular/core';
import {User} from '../models/user.model';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class UserDetailService {

  constructor(
    private _http: CustomHttp
  ) {
  }

  getUserById(id: number | string): Observable<User> {
    return this._http.get(`/apps/umng/user/${id}?withEditableInformation=true`);
  }

  deleteUser(userId: number): Observable<any> {
    return this._http.delete(`/apps/umng/user/${userId}`);
  }

  saveOrCreateUser(user: User): Observable<any> {
    return this._http.post(`/apps/umng/api/user`, user);
  }

  sendVerificationEmail(userId: number): Observable<any> {
    return this._http.post(`/apps/umng/api/user/send-link/${userId}`, {}).pipe(
      catchError((err:Response) => {return observableThrowError(err); }),
      map((res) => {
        return res;
      })
    );
  }

}
